import { render, staticRenderFns } from "./CustomerParameter.vue?vue&type=template&id=5c2b4fd4&"
import script from "./CustomerParameter.vue?vue&type=script&lang=js&"
export * from "./CustomerParameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports